import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23bdef00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-0 m-0 justify-content-center" }
const _hoisted_2 = { class: "grid product-modal-content" }
const _hoisted_3 = { class: "grid col-12 md:col-5 lg:col-5 xl:col-3 p-0 m-0 justify-content-center product-image" }
const _hoisted_4 = { class: "grid col-10 md:col-11 lg:col-11 xl:col-11 p-0 m-0 lg:pr-3 xl:pl-3 justify-content-center" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 2,
  class: "grid col-12 p-0 m-0 mt-3 justify-content-center font-bold text-sm"
}
const _hoisted_7 = { class: "grid col product-info" }
const _hoisted_8 = { class: "grid col-12 mt-2 flex product-info" }
const _hoisted_9 = { class: "grid col-12 p-0 m-0 text-2xl lg:text-base product-title lg:pr-5 text-justify md:text-left" }
const _hoisted_10 = { class: "grid col-12 pb-0" }
const _hoisted_11 = { class: "grid col-12 p-0 product-part-no" }
const _hoisted_12 = {
  key: 0,
  class: "grid col-12 pb-2"
}
const _hoisted_13 = { class: "flex product-ranking" }
const _hoisted_14 = { class: "grid col-12 pt-1 justify-content-center sm:justify-content-start align-items-center pb-0" }
const _hoisted_15 = { class: "flex product-price mr-2 sm:mr-5" }
const _hoisted_16 = { class: "grid col-12 p-0 m-0 characteristics-section" }
const _hoisted_17 = { class: "grid col-12 p-0 m-0 justify-content-center align-items-center lg:justify-content-between" }
const _hoisted_18 = {
  key: 1,
  class: "col-12 grid p-0 m-0"
}
const _hoisted_19 = { class: "product-characteristic" }
const _hoisted_20 = {
  key: 2,
  class: "col product-characteristic-title"
}
const _hoisted_21 = {
  key: 3,
  class: "grid col-12 p-0 m-0 mt-1 justify-content-center font-bold text-sm"
}
const _hoisted_22 = {
  key: 0,
  class: "grid col-12 pb-0 mb-1"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "col-12 font-bold text-sm pb-0" }, "Resources", -1))
const _hoisted_24 = { class: "pt-2 mt-0 pl-4" }
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 0,
  class: "grid col-12 p-3"
}
const _hoisted_27 = { class: "col-12 related-parts-content" }
const _hoisted_28 = { class: "related-parts-title mb-3" }
const _hoisted_29 = {
  key: 1,
  class: "option-groups"
}
const _hoisted_30 = {
  key: 0,
  class: "p-3 mb-2 border-l-4"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-info-circle",
    style: {"margin-right":"0.2rem","color":"red"}
  }),
  /*#__PURE__*/_createTextVNode(" A selection is required for this option group. ")
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 2,
  class: "col-12 text-center text-gray-500 p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Galleria = _resolveComponent("Galleria")!
  const _component_Rating = _resolveComponent("Rating")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_RelatedPartsTableSkeleton = _resolveComponent("RelatedPartsTableSkeleton")!
  const _component_POSPartsTable = _resolveComponent("POSPartsTable")!
  const _component_CollapsibleSection = _resolveComponent("CollapsibleSection")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Dialog, {
      visible: _ctx.showProductDetails,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showProductDetails) = $event)),
      modal: "",
      style: 'width: 75vw',
      breakpoints: { '1700px': '75vw', '1180px': '85vw', '768px': '100vw' },
      class: "product-details-modal",
      escape: "",
      onHide: _ctx.closeDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                    key: 0,
                    style: {"width":"50px","height":"50px"},
                    strokeWidth: "3",
                    class: "mt-2"
                  }))
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_Galleria, {
                    key: 1,
                    value: _ctx.productInfo.images,
                    numVisible: _ctx.numImagesVisible,
                    circular: true,
                    class: "grid col-12 custom-galleria"
                  }, {
                    item: _withCtx((slotProps) => [
                      _createVNode(_component_Image, {
                        src: slotProps.item.image_path,
                        alt: slotProps.item.image_desc,
                        class: "col-12 p-0 m-0 image",
                        preview: ""
                      }, null, 8, ["src", "alt"])
                    ]),
                    thumbnail: _withCtx((slotProps) => [
                      _createElementVNode("img", {
                        src: slotProps.item.image_path,
                        alt: slotProps.item.image_desc,
                        class: "col-12 p-0 pt-1"
                      }, null, 8, _hoisted_5)
                    ]),
                    _: 1
                  }, 8, ["value", "numVisible"]))
                : _createCommentVNode("", true),
              (_ctx.productInfo.images.length === 0 && !_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "No images available"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.productInfo.wrap_desc), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, " Part# " + _toDisplayString(_ctx.productInfo.part_no) + " " + _toDisplayString(_ctx.productInfo.manufactured_part ? '| Manufacturer Part #': '') + " " + _toDisplayString(_ctx.productInfo.manufactured_part), 1),
                (!_ctx.productInfo.total_ratings)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_Rating, {
                        modelValue: _ctx.productInfo.rating,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productInfo.rating) = $event)),
                        cancel: false,
                        readonly: "",
                        class: "flex"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.productInfo.total_ratings) + " ratings | " + _toDisplayString(_ctx.productInfo.answered_questions) + " answered questions ", 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, "$" + _toDisplayString(_ctx.totalAmount), 1),
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.productQty,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productQty) = $event)),
                    inputId: "horizontal-buttons",
                    showButtons: "",
                    buttonLayout: "horizontal",
                    step: _ctx.calculateStep(_ctx.selectedProduct),
                    min: 0,
                    decrementButtonClass: "input-number-button",
                    incrementButtonClass: "input-number-button",
                    incrementButtonIcon: "pi pi-plus",
                    decrementButtonIcon: "pi pi-minus",
                    class: "flex product-qty m-0"
                  }, null, 8, ["modelValue", "step"]),
                  _createVNode(_component_Button, {
                    label: "Add to Cart",
                    icon: "pi pi-check",
                    class: "flex ml-2 sm:ml-5 add-order-button",
                    onClick: _ctx.addProductToCart
                  }, null, 8, ["onClick"])
                ]),
                _createVNode(_component_Divider),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                          key: 0,
                          style: {"width":"50px","height":"50px"},
                          strokeWidth: "3"
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.productInfo.product_characteristics && _ctx.productInfo.product_characteristics.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productInfo.product_characteristics, (spec) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: spec,
                              class: "flex col-12 sm:col-6 lg:col-6 xl:col-4 pb-0"
                            }, [
                              _createElementVNode("small", _hoisted_19, "- " + _toDisplayString(spec["specs_desc"] || spec['specs']), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(_ctx.loading ? '  loading...' : ''), 1)),
                    ((!_ctx.productInfo.product_characteristics || _ctx.productInfo.product_characteristics.length === 0) && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, "There are no specs"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_Divider),
                  (_ctx.productInfo.resources && _ctx.productInfo.resources.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("ul", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productInfo.resources, (item, key) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: key,
                              class: "ml-0"
                            }, [
                              _createElementVNode("a", {
                                href: item.url,
                                target: "_new",
                                class: "p-column-title link-style block p-0 m-0 text-justify"
                              }, _toDisplayString(item.label), 9, _hoisted_25)
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        (_ctx.showRelatedParts)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.partOptionGroupHeader), 1),
                (_ctx.loadingRelatedParts)
                  ? (_openBlock(), _createBlock(_component_RelatedPartsTableSkeleton, { key: 0 }))
                  : (_ctx.groupedRelatedParts && Object.keys(_ctx.groupedRelatedParts).length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedRelatedParts, (groupData, groupId) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: groupId,
                            class: "mb-3"
                          }, [
                            _createVNode(_component_CollapsibleSection, {
                              "is-open": _ctx.groupExpandedStates[groupId],
                              header: _ctx.getGroupHeader(groupData.group_info, groupId),
                              "onUpdate:isOpen": (value) => _ctx.toggleOptionGroup(groupId, value),
                              class: _normalizeClass({ 'required-group': _ctx.isGroupRequired(groupData.group_info) })
                            }, {
                              content: _withCtx(() => [
                                (_ctx.isSelectionRequiredAndMissing(groupData.group_info, groupId))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_POSPartsTable, {
                                  value: groupData.relations,
                                  "show-add-to-cart-btn": true,
                                  showPaginator: true,
                                  "scroll-height": "300px",
                                  onAddToCart: _ctx.onRelatedPartAddToCart
                                }, null, 8, ["value", "onAddToCart"])
                              ]),
                              _: 2
                            }, 1032, ["is-open", "header", "onUpdate:isOpen", "class"])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_33, " No related parts available "))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "onHide"])
  ]))
}